/**
 * useRedirects — TanStack Query hook for the active 301/302 redirect
 * list managed from WP Admin → Tools → 301 Redirections.
 *
 * A relatively long `staleTime` matches the list's own change frequency
 * (an admin edits this occasionally, not on every request) and mirrors
 * the pattern used by `useSettings` for the same reason — this list is
 * checked on every single route change (see `App.tsx`'s `useRedirectGate`),
 * so keeping it cached rather than refetching per-navigation matters for
 * perceived routing speed.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchActiveRedirects, type RedirectRule } from '@/api/redirects';

const REDIRECTS_STALE_TIME_MS = 5 * 60 * 1000;

export function useRedirects(): UseQueryResult<RedirectRule[]> {
  return useQuery({
    queryKey: ['redirects', 'active'],
    queryFn: fetchActiveRedirects,
    staleTime: REDIRECTS_STALE_TIME_MS,
  });
}
